module.exports = __webpack_public_path__ + "files/a1250f756f16a26415785a5cfa98c243.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/droidserif-bold-webfont.svg
 ** module id = 894
 ** module chunks = 0
 **/